import { z } from 'zod';
import { shiftParticipantSchema } from '../shared/entities/shiftParticipantTypes';
const requestShiftParticipationParamsSchema = z.object({
    shiftId: z.string().uuid(),
    showContactInfo: z.boolean(),
    requestedPositions: z.string().trim().min(1).array(),
});
const requestShiftParticipationResponseSchema = z.object({
    id: z.string().uuid(),
    data: shiftParticipantSchema
        .extend({
        countyTribe: z.string().optional(),
    })
        .optional(),
    columns: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
});
const partialRequestShiftParticipationResponseSchema = requestShiftParticipationResponseSchema.omit({
    data: true,
    columns: true,
});
export const requestShiftParticipationFunctionDef = {
    name: 'requestShiftParticipation',
    requestSchema: requestShiftParticipationParamsSchema,
    responseSchema: requestShiftParticipationResponseSchema.array().optional(),
};
